import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import LoginPage from "./LoginPage";
import ProtectedRoute from "./ProtectedRoute";
import Vehicles from "./components/Vehicle/Vehicles";
import { useJsApiLoader } from "@react-google-maps/api";
import Overview from "./components/Vehicle/Overview";
import DealerPage from "./components/Dealer/DealerPage";

const GOOGLE_LIBS = ["marker"]; // keep static

export default function App() {
	const maps = useJsApiLoader({
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
		libraries: GOOGLE_LIBS,
	});

	return (
		<Router>
			<Routes>
				<Route path="/login" element={<LoginPage />} />
				<Route
					path="/vehicles"
					element={
						<ProtectedRoute>
							<Vehicles maps={maps} />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/vehicles/:vehicleId"
					element={
						<ProtectedRoute>
							<Vehicles maps={maps} />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/dealers/:dealerId"
					element={
						<ProtectedRoute>
							<DealerPage />
						</ProtectedRoute>
					}
				/>
				<Route path="/" element={<Navigate to="/vehicles" replace />} />
				<Route path="*" element={<Navigate to="/vehicles" replace />} />
				<Route
					path="/overview"
					element={
						<ProtectedRoute>
							<Overview maps={maps} />
						</ProtectedRoute>
					}
				/>
			</Routes>
		</Router>
	);
}
